var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-brand-component",on:{"click":function($event){return _vm.$emit('add-item')}}},[_c('span',{staticClass:"add-brand-component__button"},[_c('i',{staticClass:"icon-plus"}),(_vm.title)?_c('span',{staticClass:"add-brand-component__text"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }